"use client";

import * as React from "react";
import { usePathname } from "next/navigation";
import { findHeadingElement, highlightSection } from "./docs-section-utils";

/**
 * Cuando el usuario navega a una doc con un `#hash` (típicamente al clicar
 * un link de Faki), espera a que el DOM esté listo, hace scroll suave al
 * heading y lo resalta brevemente. Funciona también con texto descriptivo
 * pasado vía `sessionStorage` (fallback cuando el slug no coincide 1:1).
 */
export function DocsHashHandler() {
  const pathname = usePathname();

  React.useEffect(() => {
    const tryScroll = () => {
      const hash = window.location.hash.replace(/^#/, "");
      if (!hash) return false;
      const fallback =
        window.sessionStorage.getItem(`docs-section-text:${hash}`) ?? undefined;
      const el = findHeadingElement(decodeURIComponent(hash), fallback);
      if (!el) return false;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      // Highlight con pequeño delay para que termine la animación de scroll
      setTimeout(() => highlightSection(el), 250);
      // Limpia fallback ya usado
      window.sessionStorage.removeItem(`docs-section-text:${hash}`);
      return true;
    };

    // Reintentos cortos por si el contenido aún no renderizó tras navigation
    let tries = 0;
    const id = setInterval(() => {
      if (tryScroll() || ++tries > 20) clearInterval(id);
    }, 80);

    const onHash = () => tryScroll();
    window.addEventListener("hashchange", onHash);
    return () => {
      clearInterval(id);
      window.removeEventListener("hashchange", onHash);
    };
  }, [pathname]);

  return null;
}
